import React from 'react';
import Footer from '../components/Footer';


export default function TnC() {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms and Conditions</h1>
      <p><strong>Last updated:</strong> August 7, 2025</p>

      <p>Welcome to <strong>Slipmart</strong>! By accessing or using our website (www.Slipmart.com), you agree to be bound by the following terms and conditions. Please read them carefully before using our services.</p>

      <h2>1. Use of Our Website</h2>
      <ul>
        <li>You must be at least 13 years old to use our site.</li>
        <li>You agree not to use our site for illegal or unauthorized purposes.</li>
        <li>You may not duplicate, copy, sell, or exploit any part of the website without permission.</li>
      </ul>

      <h2>2. Product Information</h2>
      <p>We try to ensure all product descriptions, images, and prices are accurate. However, we don’t guarantee everything will be 100% error-free. We reserve the right to update or cancel any orders if needed.</p>

      <h2>3. Orders & Payments</h2>
      <ul>
        <li>All orders depend on availability and confirmation.</li>
        <li>Prices are shown in INR and include applicable taxes unless mentioned.</li>
        <li>We accept payments via UPI, Debit/Credit Cards, and other listed methods.</li>
      </ul>

      <h2>4. Shipping & Delivery</h2>
      <p>Shipping times are estimated and may vary. Eshop is not responsible for delays due to courier services or unforeseen circumstances.</p>

      <h2>5. Returns & Refunds</h2>
      <p>We offer returns within 7 days of delivery for eligible products. The product must be unused and in original packaging. Refunds are processed within 5–7 business days after inspection.</p>

      <h2>6. Intellectual Property</h2>
      <p>All content on Eshop (logo, text, images, etc.) is the property of Eshop and protected under copyright laws. Unauthorized use is strictly prohibited.</p>

      <h2>7. Limitation of Liability</h2>
      <p>We are not liable for any damages or losses arising from your use of our website or products.</p>

      <h2>8. Changes to Terms</h2>
      <p>We may update these Terms and Conditions at any time. Continued use of the website means you accept the updated terms.</p>

      <h2>9. Contact Us</h2>
      <p>If you have any questions, contact us at <a href="mailto:support@slipmart.com">support@slipmart.com</a>.</p>

      <p style={{ marginTop: "2rem" }}><em>Thank you for shopping with Slipmart! 😊</em></p>
    </div>
  )
}